import SvgIcon from "@mui/material/SvgIcon";

const Spanish = function () {
  return (
    <SvgIcon viewBox="0 0 22 18">
      <rect width="22.4" height="16" rx="2" fill="white" />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="23"
        height="16"
      >
        <rect width="22.4" height="16" rx="2" fill="white" />
      </mask>
      <g mask="url(#mask0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 4.26667H22.4V0H0V4.26667Z"
          fill="#DD172C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 16H22.4V11.7333H0V16Z"
          fill="#DD172C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 11.7333H22.4V4.26666H0V11.7333Z"
          fill="#FFD133"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.8667 7.46666H6.93337V7.99999H5.8667V7.46666Z"
          fill="#FFEDB1"
        />
        <path
          d="M4.9258 7.62767C4.9096 7.43333 5.06297 7.26665 5.25798 7.26665H6.47558C6.67059 7.26665 6.82396 7.43333 6.80776 7.62767L6.68985 9.04265C6.65418 9.47072 6.29633 9.79999 5.86678 9.79999C5.43723 9.79999 5.07939 9.47072 5.04371 9.04265L4.9258 7.62767Z"
          stroke="#A41517"
          strokeWidth="0.666667"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.80005 8H6.93338V8.53333H6.40005L5.86672 9.6L5.33338 8.53333H4.80005V8Z"
          fill="#A41517"
        />
        <rect
          x="3.19995"
          y="6.39999"
          width="1.06667"
          height="3.73333"
          rx="0.533333"
          fill="#A41517"
        />
        <rect
          x="7.46655"
          y="6.39999"
          width="1.06667"
          height="3.73333"
          rx="0.533334"
          fill="#A41517"
        />
        <path
          d="M4.80005 6.18668C4.80005 5.71539 5.1821 5.33334 5.65338 5.33334H6.08005C6.55133 5.33334 6.93338 5.71539 6.93338 6.18668C6.93338 6.3045 6.83787 6.40001 6.72005 6.40001H5.01338C4.89556 6.40001 4.80005 6.3045 4.80005 6.18668Z"
          fill="#A41517"
        />
      </g>
    </SvgIcon>
  );
};
export default Spanish;
